export default "__VITE_ASSET__D9BJsXlP__"